/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useState, useEffect, useMemo } from "react";
import { ReactComponent as ArrowRightIcon } from "assets/images/icons/common/arrow-right.svg";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import { FeatureNewsItem } from "./feature-news-item";
import { RecentNewsItem } from "./recent-news-item";
import Config from "data/config";
import { useAuth } from "cms/auth/hooks/use-auth";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";

const NewsHighlightsComponentDisplay = () => {

    const { token } = useAuth();
    const { component } = useUpdateComponent();
    console.log("component::", component);
    
    const heading = component?.heading;
    const featuredNewsHeading = component?.featured_news_heading;
    const subHeading = component?.sub_heading;
    const featuredPages = component?.featured_pages;
    const allNewsLinkGuid = component?.all_news_link;
    const showDescription = component?.show_description;
    const category = component?.category;
    const [allNewsLink, setAllNewsLink] = useState();
    const [recentNews, setRecentNews] = useState();

    useEffect(() => {
        if (!token) {
            return;
        }
        // Fetch recent news
        const getRecentNews = async () => {
            const options = {
                modelType: "model.news-subtype",
                page: 1,
                pageSize: 100,
                sort: "published_at",
                sortDir: "desc",
                category: category,
            };
            console.log("options before SDK call::", JSON.stringify(options, null, 2));
            console.log("options.sort::", options.sort);
            console.log("options.sortDir::", options.sortDir);
            const recentNewsData = await SimpliCityAdminSDK.webpage.advancedSearch(token, options);
            console.log("recentNews::", recentNewsData);
            setRecentNews(recentNewsData?.results);
        };
        getRecentNews();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);
    useEffect(() => {
        if (allNewsLinkGuid) {
            const getLink = async () => {
                try {
                    const link = await SimpliCityAdminSDK.link.findOne(token, allNewsLinkGuid);
                    if (link) {
                        setAllNewsLink(link);
                    } else {
                        setAllNewsLink(undefined);
                    }
                } catch (e) {
                    setAllNewsLink(undefined);
                }
            };
            getLink();
        } else {
            setAllNewsLink(undefined);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allNewsLinkGuid]);

    const handleAllNewsClick = () => {
        if (allNewsLink?.url) {
            const url = allNewsLink.link_type === "internal" 
                ? `${Config.previewUrl}${allNewsLink.url}`
                : allNewsLink.url;
            window.open(url, "_blank");
        }
    };

    // Filter recentNews to exclude featuredPages and limit to 4
    const filteredRecentNews = useMemo(() => {
        if (!recentNews) {
            return [];
        }
        const excludedGuids = new Set();
        
        // Add featured pages GUIDs
        if (featuredPages) {
            featuredPages.forEach(page => {
                if (page.webpage) {
                    excludedGuids.add(page.webpage);
                }
            });
        }
        
        // Add allNewsLink GUID if it exists
        console.log("allNewsLink::", allNewsLink);
        if (allNewsLink?.guid) {
            excludedGuids.add(allNewsLink.guid);
        }
        
        const filtered = recentNews.filter(webpage => !excludedGuids.has(webpage.guid));
        return filtered.slice(0, 4);
    }, [recentNews, featuredPages, allNewsLink]);
    return (
        <div className="simplicity-news-highlights-component-display">
            <div className="simplicity-news-highlights-component-display-header">
                <div className="simplicity-news-highlights-component-display-header-title">
                    <div className="simplicity-news-highlights-component-display-header-title-text">{heading}</div>
                </div>
                <div 
                    className={`simplicity-news-highlights-component-display-header-all-news-wrapper${allNewsLink?.url ? " simplicity-news-highlights-component-display-header-all-news-wrapper-clickable" : ""}`}
                    onClick={handleAllNewsClick}
                >
                    <div className="simplicity-news-highlights-component-display-header-all-news-text">
                        All news
                    </div>
                    <div className="simplicity-news-highlights-component-display-header-all-news-icon">
                        <ArrowRightIcon />
                    </div>
                </div>
            </div>
            <div className="simplicity-news-highlights-component-display-content">
                <div className="simplicity-news-highlights-component-display-content-featured-news-wrapper">
                    <div className="simplicity-news-highlights-component-display-content-featured-news-title">
                        <div className="simplicity-news-highlights-component-display-content-featured-news-title-text">
                            {featuredNewsHeading}
                        </div>
                        {/* TODO: Add featured news items here with component */}
                        <div className="simplicity-news-highlights-component-display-content-featured-news-items">
                            {featuredPages?.slice(0, 2).map((webpage) => (
                                <FeatureNewsItem key={webpage.guid} webpage={webpage} showDescription={showDescription} />
                            ))}
                        </div>
                    </div>
                </div>
                <div className="simplicity-news-highlights-component-display-content-recent-news-wrapper">
                    <div className="simplicity-news-highlights-component-display-content-recent-news-title">
                        <div className="simplicity-news-highlights-component-display-content-recent-news-title-text">
                            {subHeading}
                        </div>
                        {/* TODO: Add recent news items here with component */}
                        {/* <RecentNewsItem /> */}
                        <div className="simplicity-news-highlights-component-display-content-recent-news-items">
                            {filteredRecentNews?.map((webpage) => (
                                <RecentNewsItem key={webpage.guid} webpage={webpage} showDescription={showDescription} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

NewsHighlightsComponentDisplay.displayName = "NewsHighlightsComponentDisplay";
export { NewsHighlightsComponentDisplay };

